import { autoMount } from '../../../utils/autoMount';
import { UnLoggedInHeader } from '../../../components/organisms/unLoggedInHeader';

autoMount({ UnLoggedInHeader });
